"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Body = function Body(_ref) {
  var children = _ref.children,
      bold = _ref.bold,
      italic = _ref.italic,
      light = _ref.light,
      smaller = _ref.smaller,
      tiny = _ref.tiny,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["children", "bold", "italic", "light", "smaller", "tiny", "className"]);

  return /*#__PURE__*/_react.default.createElement(StyledBody, _extends({
    bold: bold,
    italic: italic,
    light: light,
    smaller: smaller,
    tiny: tiny,
    className: className
  }, otherProps), children);
};

var StyledBody = _styledComponents.default.p.withConfig({
  displayName: "StyledBody"
})(["font-family:", ";font-style:", ";font-weight:", ";color:", ";font-size:", ";line-height:", ";> a{color:", ";text-decoration:underline;&:hover{text-decoration:none;}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
}, function (_ref3) {
  var italic = _ref3.italic;
  return italic ? 'italic' : 'normal';
}, function (_ref4) {
  var bold = _ref4.bold;
  return bold ? '500' : 'normal';
}, function (_ref5) {
  var theme = _ref5.theme,
      light = _ref5.light;
  return light ? '#8990a3' : theme.font.text;
}, function (_ref6) {
  var smaller = _ref6.smaller,
      tiny = _ref6.tiny;
  return smaller ? '1.4rem' : tiny ? '1.2rem' : '1.6rem';
}, function (_ref7) {
  var smaller = _ref7.smaller,
      tiny = _ref7.tiny;
  return smaller ? '1.6rem' : tiny ? '1.5rem' : '2rem';
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.brand.primary;
});

Body.propTypes = {
  children: _propTypes.node.isRequired,

  /** Pass this prop if the text inside should be bold. */
  bold: _propTypes.bool,

  /** Pass this prop if the text inside should be italic. */
  italic: _propTypes.bool,

  /** Pass this prop to make the text lighter. */
  light: _propTypes.bool,

  /** Pass this prop to reduce the font size to approx. 14px */
  smaller: _propTypes.bool,

  /** Pass this prop to reduce the font size to approx. 12px  */
  tiny: _propTypes.bool,
  className: _propTypes.string,
  otherProps: _propTypes.object
};
var _default = Body;
exports.default = _default;